import {Grid} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

export const GridCentered = withStyles({
   root: {
      alignSelf: 'center',
   },
})(Grid);
